/**
 * Copy rich text (HTML, for pasting a formatted table into Gmail / Docs) with
 * a plain-text twin for targets that only take text. Falls back to plain
 * text where the browser can't write text/html (no ClipboardItem, or the
 * write is refused). Throws only when the clipboard can't be written at all.
 */
export async function copyRichText(html: string, text: string): Promise<'rich' | 'plain'> {
  const clipboard = typeof navigator !== 'undefined' ? navigator.clipboard : undefined;
  if (!clipboard) throw new Error('Clipboard unavailable');
  if (typeof clipboard.write === 'function' && typeof ClipboardItem !== 'undefined') {
    try {
      await clipboard.write([
        new ClipboardItem({
          'text/html': new Blob([html], { type: 'text/html' }),
          'text/plain': new Blob([text], { type: 'text/plain' }),
        }),
      ]);
      return 'rich';
    } catch {
      // Some browsers refuse text/html writes — plain text still beats nothing.
    }
  }
  await clipboard.writeText(text);
  return 'plain';
}
